import { MonthConfig } from "./DateInputTypes"

export function addLeadingZero(value: string | number): string {
  return ("0" + value).slice(-2)
}

function isLeapYear(year: number): boolean {
  return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0
}

export const monthInfo: MonthConfig[] = [
  {
    name: "Jan",
    getDays: () => 31
  },
  {
    name: "Feb",
    getDays: (year) => {
      return year ? (isLeapYear(year.value) ? 29 : 28) : 29
    }
  },
  {
    name: "Mar",
    getDays: () => 31
  },
  {
    name: "Apr",
    getDays: () => 30
  },
  {
    name: "May",
    getDays: () => 31
  },
  {
    name: "Jun",
    getDays: () => 30
  },
  {
    name: "Jul",
    getDays: () => 31
  },
  {
    name: "Aug",
    getDays: () => 31
  },
  {
    name: "Sep",
    getDays: () => 30
  },
  {
    name: "Oct",
    getDays: () => 31
  },
  {
    name: "Nov",
    getDays: () => 30
  },
  {
    name: "Dec",
    getDays: () => 31
  }
]

export function calculateInputValue({ month, day, year }): string {
  if (!day || !month || !year) {
    return ""
  } else {
    const yearValue = year.value
    const dayValue = addLeadingZero(day.value)
    const monthValue = addLeadingZero(month.value)
    return `${yearValue}-${monthValue}-${dayValue}`
  }
}

export function getMonth(monthNum: number): MonthConfig {
  return monthInfo[monthNum - 1]
}
